/* Mobile product gallery: arrows + slide counter */
(function(){
  if(window.innerWidth>=720)return; /* Slider nur unter 720px (Theme-Breakpoint S) */

  function init(){
    var viewer=document.querySelector('.product-gallery--viewer');
    if(!viewer||!viewer.classList.contains('flickity-enabled'))return setTimeout(init,500);
    if(viewer.querySelector('.sk-arrow'))return;

    var cells=Array.from(viewer.querySelectorAll('.product-gallery--media'));
    if(cells.length<2)return;
    var total=cells.length;

    function getCurrent(){
      for(var i=0;i<cells.length;i++){
        if(cells[i].classList.contains('is-selected'))return i;
      }
      return 0;
    }

    /* Navigate by clicking the thumbnail navigation (hidden but functional) */
    var thumbs=document.querySelectorAll('.product-gallery--media-thumbnail');

    function goTo(idx){
      /* Method 1: Click hidden thumbnail */
      if(thumbs.length>idx){
        thumbs[idx].click();
        return;
      }
      /* Method 2: Dispatch flickity select via custom event */
      var evt=new CustomEvent('flickity:select',{detail:{index:idx}});
      viewer.dispatchEvent(evt);
      /* Method 3: Direct scroll */
      var target=cells[idx];
      if(target){
        var slider=viewer.querySelector('.flickity-slider');
        if(slider){
          var offset=target.offsetLeft;
          slider.style.transform='translateX(-'+offset+'px)';
        }
      }
    }

    /* Create arrows */
    var prevBtn=document.createElement('button');
    prevBtn.className='sk-arrow sk-arrow--prev';
    prevBtn.setAttribute('type','button');
    prevBtn.setAttribute('aria-label','Vorheriges Bild');
    prevBtn.innerHTML='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';

    var nextBtn=document.createElement('button');
    nextBtn.className='sk-arrow sk-arrow--next';
    nextBtn.setAttribute('type','button');
    nextBtn.setAttribute('aria-label','Naechstes Bild');
    nextBtn.innerHTML='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';

    prevBtn.addEventListener('click',function(e){
      e.preventDefault();e.stopPropagation();
      var cur=getCurrent();
      var next=(cur-1+total)%total;
      goTo(next);
    });

    nextBtn.addEventListener('click',function(e){
      e.preventDefault();e.stopPropagation();
      var cur=getCurrent();
      var next=(cur+1)%total;
      goTo(next);
    });

    /* Counter badge */
    var counter=document.createElement('div');
    counter.className='sk-counter';
    counter.textContent=(getCurrent()+1)+'/'+total;

    viewer.appendChild(prevBtn);
    viewer.appendChild(nextBtn);
    viewer.appendChild(counter);

    /* Watch for slide changes */
    var observer=new MutationObserver(function(){
      counter.textContent=(getCurrent()+1)+'/'+total;
    });
    cells.forEach(function(c){
      observer.observe(c,{attributes:true,attributeFilter:['class']});
    });
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){setTimeout(init,1500)});
  else setTimeout(init,1500);
})();

/* Fix video subtitles: resize viewer to fit video when video slide is selected */
(function(){
  /* Only run on pages that actually have a video in the gallery */
  if (!document.querySelector('.product-gallery--video-thumbnail')) return;
  if (window.innerWidth <= 768) return; /* Skip on mobile */

  function fixVideoHeight(){
    var viewer = document.querySelector('.product-gallery--viewer');
    if (!viewer) return;
    var origMaxH = getComputedStyle(viewer).maxHeight;
    var origH = viewer.style.height;

    function adjustForVideo(){
      var selected = document.querySelector('.product-gallery--media.is-selected');
      var video = selected ? selected.querySelector('video') : null;
      if (video) {
        var w = viewer.offsetWidth;
        viewer.style.setProperty('max-height', w + 'px', 'important');
        viewer.style.setProperty('height', w + 'px', 'important');
      } else {
        /* Restore original values, never remove */
        if (origH) viewer.style.height = origH;
        if (origMaxH) viewer.style.maxHeight = origMaxH;
      }
    }

    /* Only listen for thumbnail clicks, not MutationObserver (too aggressive) */
    document.querySelectorAll('.product-gallery--video-thumbnail, .product-gallery--media-thumbnail').forEach(function(t){
      t.addEventListener('click', function(){ setTimeout(adjustForVideo, 500); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixVideoHeight);
  else fixVideoHeight();
})();

/* 18.10.2026: Galerie-Bilder erst bei Bedarf.
   Nicht ausgewaehlte Slides liegen vor dem Slider-Start per CSS (sk-product.css) ausserhalb des Viewports,
   damit rimg nicht mehr alle ~9 Bilder sofort laedt (vorher lagen sie unsichtbar direkt unter dem Hauptbild).
   Damit Wischen/Klicken trotzdem sofort ein Bild zeigt, waermt dieser Block nach dem load-Event den
   Browser-Cache fuer die Nachbar-Slides vor - mit exakt der URL, die rimg spaeter selbst anfordert
   (gleiche Groessenberechnung wie rimg setImage/supportedDensity, round=1). Attribute bleiben unangetastet. */
(function(){
  var warmed={};
  function figures(){return Array.prototype.slice.call(document.querySelectorAll('.product-gallery--viewer [data-gallery-figure]'));}
  function rimgUrl(img){
    var tpl=img.getAttribute('data-rimg-template');if(!tpl)return null;
    var el=img,w=0,h=0;
    while(el&&el.nodeType===1){w=el.offsetWidth;h=el.offsetHeight;if(w>20&&h>20)break;el=el.parentNode;}
    if(!(w>20&&h>20))return null;
    var scale=parseInt(img.getAttribute('data-rimg-scale'),10)||1;w*=scale;h*=scale;
    var mx=(img.getAttribute('data-rimg-max')||'').split('x'),mw=parseInt(mx[0],10)||Infinity,mh=parseInt(mx[1],10)||Infinity;
    var dpr=window.devicePixelRatio||1;
    var d=+Math.min(Math.min(Math.max(mw/w,1),dpr),Math.min(Math.max(mh/h,1),dpr)).toFixed(2);
    var tw=w*d,th=h*d,iar=(isFinite(mw)&&isFinite(mh))?mw/mh:w/h,W,H;
    function r(v,m){return v===0?1:Math.min(Math.ceil(v),m);}
    if(img.getAttribute('data-rimg-crop')&&img.getAttribute('data-rimg-crop')!=='false'){W=r(tw,mw);H=r(th,mh);}
    else if(w/h>iar){W=r(tw,mw);H=r(tw/iar,mh);}else{W=r(th*iar,mw);H=r(th,mh);}
    return tpl.replace('{size}',W+'x'+H);
  }
  function warm(fig){
    if(!fig)return;
    var img=fig.querySelector('img[data-rimg="lazy"][data-rimg-template]');if(!img)return;
    var url=rimgUrl(img);if(!url||warmed[url])return;
    warmed[url]=1;var pre=new Image();pre.decoding='async';pre.src=url;
  }
  function warmAround(){
    var f=figures();if(f.length<2)return;
    var s=0;for(var i=0;i<f.length;i++){if(f[i].getAttribute('data-gallery-selected')==='true'){s=i;break;}}
    warm(f[(s+1)%f.length]);warm(f[(s-1+f.length)%f.length]);warm(f[(s+2)%f.length]);
  }
  function start(){
    warmAround();
    var f=figures();
    if(window.MutationObserver&&f.length){
      var mo=new MutationObserver(function(){warmAround();});
      for(var i=0;i<f.length;i++)mo.observe(f[i],{attributes:true,attributeFilter:['data-gallery-selected']});
    }
    var v=document.querySelector('.product-gallery--viewer');
    if(v)v.addEventListener('pointerdown',warmAround,{passive:true});
  }
  function idle(){if('requestIdleCallback' in window)requestIdleCallback(start,{timeout:3000});else setTimeout(start,1500);}
  if(document.readyState==='complete')idle();else window.addEventListener('load',idle,{once:true});
})();
